type Region = 'IR' | 'Default' | string;

const phoneNumberRegEx: { [x in Region]: RegExp } = {
  IR: /^(\+98|98|0098|0|)([9][0-9]{9})$/g,
  Default: /^(\D*)([0-9]{0,})$/g,
};

/**
 * Extracts prefix from `phoneNumber`
 * @param phone `phoneNumber` with/without prefix
 * @param region target region of `phoneNumber`
 * @returns `phoneNumber` without prefix
 */
export const phoneNumberExtractor = (phone: string, region: Region): string => {
  const regExp = phoneNumberRegEx[region] ?? phoneNumberRegEx.Default;
  return phone.replace(regExp, '$2');
};
